var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMyprofile = function SvgIconMyprofile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0a10 10 0 1 1-7.071 2.929A9.97 9.97 0 0 1 10 0m0 3.666a2.992 2.992 0 1 1-2.115.876A2.98 2.98 0 0 1 10 3.665Zm1.355 1.64a1.916 1.916 0 1 0 .561 1.355 1.9 1.9 0 0 0-.561-1.355M2.862 15.359a6.64 6.64 0 0 1 2.289-2.978 8.32 8.32 0 0 1 9.7 0 6.64 6.64 0 0 1 2.289 2.978 8.926 8.926 0 1 0-14.277 0Zm13.451.952a5.45 5.45 0 0 0-2.1-3.069 7.26 7.26 0 0 0-8.422 0 5.44 5.44 0 0 0-2.1 3.069 8.925 8.925 0 0 0 12.623 0Z",
    "data-name": "Path 5931"
  })));
};
export default SvgIconMyprofile;